export const BUTTON_VARIANTS = {
  outlined: 'outlined',
  fulfilled: 'fulfilled',
  link: 'link',
} as const;
